<template>
  <div v-if="minimizedWindows.length > 0" class="minimized-tickets-bar">
    <div class="minimized-tickets-container">
      <div
        v-for="window in minimizedWindows"
        :key="window.id"
        class="minimized-ticket-item"
        @click="restoreWindow(window.id)"
      >
        <div class="minimized-ticket-icon">
          <i class="ri-ticket-2-line"></i>
        </div>
        <div class="minimized-ticket-info">
          <div class="minimized-ticket-title">
            <span v-if="window.tickets.length === 1">
              #{{ window.tickets[0].ticketId }} - {{ truncate(window.tickets[0].ticketName, 30) }}
            </span>
            <span v-else>
              {{ window.tickets.length }} тікетів
            </span>
          </div>
          <div class="minimized-ticket-meta">
            <span v-if="window.tickets.length > 1">
              #{{ window.tickets.map(t => t.ticketId).join(', #') }}
            </span>
          </div>
        </div>
        <button
          class="minimized-ticket-close"
          @click.stop="closeWindow(window.id)"
          :title="$t('close')"
        >
          <i class="mdi mdi-close"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useTicketWindows } from '@/composables/useTicketWindows.js';

export default {
  name: 'MinimizedTicketsBar',
  setup() {
    const { minimizedWindows, restoreWindow, closeWindow } = useTicketWindows();

    return {
      minimizedWindows,
      restoreWindow,
      closeWindow
    };
  },
  methods: {
    truncate(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    }
  }
};
</script>

<style scoped>
.minimized-tickets-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  background: #ffffff;
  border-top: 2px solid #e9ecef;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 8px 16px;
}

.minimized-tickets-container {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  max-width: 100%;
}

.minimized-ticket-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 250px;
  max-width: 350px;
  position: relative;
  color: white;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.minimized-ticket-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.minimized-ticket-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  flex-shrink: 0;
}

.minimized-ticket-icon i {
  font-size: 20px;
  color: white;
}

.minimized-ticket-info {
  flex: 1;
  overflow: hidden;
  min-width: 0;
}

.minimized-ticket-title {
  font-size: 14px;
  font-weight: 600;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.minimized-ticket-meta {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.minimized-ticket-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
  opacity: 0.8;
}

.minimized-ticket-close:hover {
  background: rgba(255, 255, 255, 0.3);
  opacity: 1;
  transform: rotate(90deg);
}

.minimized-ticket-close i {
  font-size: 16px;
}

@media (max-width: 768px) {
  .minimized-tickets-bar {
    padding: 6px 12px;
  }

  .minimized-ticket-item {
    min-width: 200px;
    max-width: 280px;
    padding: 8px 12px;
  }

  .minimized-ticket-icon {
    width: 32px;
    height: 32px;
  }

  .minimized-ticket-icon i {
    font-size: 18px;
  }
}
</style>
